import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from '@blaze-cms/nextjs-components';
import { MdKeyboardArrowLeft, MdEdit, MdEditOff } from 'react-icons/md';
import { useRouter } from 'next/router';
import { IoCloseOutline } from 'react-icons/io5';
import { buildAdminHref, setBlazeDebug } from '../../helpers';
import { BLAZE_DEBUG, DEBUG_LOGO } from '../../constants';
import getFromLocal from '../../helpers/get-from-local';
const DebugSidebar = ({
  itemEntity,
  itemId,
  updatedDebugOptions,
  debugMode
}) => {
  const [isDebugMode, setIsDebugMode] = useState(debugMode);
  const [isEditorMode, setIsEditorMode] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const router = useRouter();
  useEffect(() => {
    // const currentEditorMode = getFromLocal(BLAZE_PB_EDITOR_MODE);
    const currentDebugValue = getFromLocal(BLAZE_DEBUG);
    setIsDebugMode(currentDebugValue);
    setIsOpen(currentDebugValue);
    setBlazeDebug(setIsDebugMode);
    // setIsEditorMode(!!currentEditorMode); // todo: initilize on load
  }, []);
  useEffect(() => {
    const handleRouteChange = url => {
      const hasDebug = url.includes(`${BLAZE_DEBUG}=1`);
      if (hasDebug) {
        setBlazeDebug(setIsDebugMode);
        setIsOpen(true);
      }
    };
    if (router.asPath.includes(`${BLAZE_DEBUG}=1`)) {
      handleRouteChange(router.asPath);
    }
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events, router.asPath]);
  const divClass = classnames('debug-sidebar', {
    'debug-sidebar--open': isOpen,
    'debug-sidebar--close': !isOpen
  });
  const toggleEditorMode = () => {
    // todo: persist editor mode in local storage
    // const currentEditorMode = getFromLocal(BLAZE_PB_EDITOR_MODE);
    // if (currentEditorMode) {
    //   window.localStorage.removeItem(BLAZE_PB_EDITOR_MODE);
    // } else {
    //   window.localStorage.setItem(BLAZE_PB_EDITOR_MODE, true);
    // }
    updatedDebugOptions('editorModeEnabled', !isEditorMode);
    updatedDebugOptions({
      editorModeEnabled: !isEditorMode,
      adminHref: buildAdminHref({
        itemEntity,
        itemId
      })
    });
    setIsEditorMode(!isEditorMode);
  };
  const href = buildAdminHref({
    itemEntity,
    itemId
  });
  if (!isDebugMode) return null;
  const closeDebug = () => {
    setBlazeDebug(setIsDebugMode);
    window.blaze.debug();
    const [pathname, search = ''] = router.asPath.split('?');
    const params = new URLSearchParams(search);
    params.delete(BLAZE_DEBUG);
    const newUrl = params.toString() ? `${pathname}?${params.toString()}` : pathname;
    router.push('/Resolver', newUrl, {
      shallow: true
    });
  };
  return createPortal(/*#__PURE__*/React.createElement("div", {
    className: divClass,
    "data-testid": "debug-sidebar"
  }, /*#__PURE__*/React.createElement(Link, {
    href: href
  }, /*#__PURE__*/React.createElement("img", {
    src: DEBUG_LOGO.SRC,
    alt: DEBUG_LOGO.ALT
  }), /*#__PURE__*/React.createElement("span", null, "Blaze admin")), /*#__PURE__*/React.createElement("div", {
    role: "button",
    className: "debug-sidebar__button debug-sidebar__button--close",
    "data-testid": "debug-sidebar-close",
    "aria-label": "Close debug sidebar",
    onClick: closeDebug
  }, /*#__PURE__*/React.createElement(IoCloseOutline, null)), /*#__PURE__*/React.createElement("div", {
    role: "button",
    className: "debug-sidebar__button debug-sidebar__button--editor",
    "data-testid": "debug-sidebar-editor-button",
    id: "debug-sidebar-editor-button",
    "aria-label": "Editor mode",
    onClick: toggleEditorMode
  }, /*#__PURE__*/React.createElement("i", null, isEditorMode ? /*#__PURE__*/React.createElement(MdEditOff, null) : /*#__PURE__*/React.createElement(MdEdit, null))), /*#__PURE__*/React.createElement("div", {
    role: "button",
    className: "debug-sidebar__button open",
    "data-testid": "debug-sidebar-button",
    id: "debug-sidebar-button",
    onClick: () => setIsOpen(!isOpen)
  }, /*#__PURE__*/React.createElement("i", null, /*#__PURE__*/React.createElement(MdKeyboardArrowLeft, null)))), document.body);
};
DebugSidebar.propTypes = {
  updatedDebugOptions: PropTypes.func.isRequired,
  itemEntity: PropTypes.string,
  itemId: PropTypes.string,
  debugMode: PropTypes.bool
};
DebugSidebar.defaultProps = {
  itemEntity: '',
  itemId: '',
  debugMode: false
};
export default DebugSidebar;
//# sourceMappingURL=index.js.map